import { Box, Typography } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { createInvoicePageSelectors, getSelectorAttribute } from '@vy/app-selectors';
import type { PlanInputFormFixedProduct } from '@vy/types';
import { isNotNullOrUndefined } from '@vy/utils';
import type { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import type { NewPlanForm } from '../../../../../plans/CreatePlanPage/create-plan-page-components/CreatePlanForm/create-plan-form-types/new-plan-form';
import type { PlanInputForm } from '../../../../../plans/CreatePlanPage/create-plan-page-components/CreatePlanForm/create-plan-form-types/plan-input-form';
import { useGetDefaultProductConfigurations } from '../../../../../plans/CreatePlanPage/create-plan-page-hooks/useGetDefaultProductConfigurations';

type CreateInvoicePageFixedChargesMenuItemsProps = {
  onAddCreditClick?: () => void;
};

export const CreateInvoicePageFixedChargesMenuItems: FC<CreateInvoicePageFixedChargesMenuItemsProps> = ({
  onAddCreditClick,
}) => {
  const { setValue, getValues } = useFormContext<PlanInputForm, NewPlanForm>();
  const { getFixedOneTimeProductConfiguration, getCommercialTermsProductConfiguration } =
    useGetDefaultProductConfigurations();

  const handleProductClick = (defaultProductCallback: () => PlanInputFormFixedProduct) => {
    return () => {
      const currentProducts = getValues('fixedProducts') ?? [];
      const defaultProduct = defaultProductCallback();
      const updatedProducts = [...currentProducts, defaultProduct];

      setValue('fixedProducts', updatedProducts);
    };
  };

  return (
    <>
      <MenuItem
        className="flex flex-col items-start"
        onClick={handleProductClick(getFixedOneTimeProductConfiguration)}
        {...getSelectorAttribute(createInvoicePageSelectors.fixedChargesTab.oneTimeFeeOption)}
      >
        <Typography className="text-sm font-normal text-black">One Time Fee</Typography>
        <Typography className="text-xs font-normal text-[#94A0A4]">Single one time charge</Typography>
      </MenuItem>

      <MenuItem
        className="flex flex-col items-start"
        onClick={handleProductClick(getCommercialTermsProductConfiguration)}
      >
        <Typography className="text-sm font-normal text-black">Contract Terms</Typography>
        <Typography className="text-xs font-normal text-[#94A0A4]">Contract commitment</Typography>
      </MenuItem>

      {isNotNullOrUndefined(onAddCreditClick) && (
        <MenuItem
          className="flex flex-col items-start"
          onClick={onAddCreditClick}
          {...getSelectorAttribute(createInvoicePageSelectors.fixedChargesTab.creditOption)}
        >
          <Box className="flex items-center gap-x-1">
            <Typography className="text-sm font-normal text-black">Credit</Typography>
            <Box
              sx={{
                borderRadius: '4px',
                bgcolor: '#E7F2FF',
                color: '#0521FF',
                fontSize: '10px',
                fontWeight: 600,
                lineHeight: 1,
                padding: '2px 4px',
              }}
            >
              New
            </Box>
          </Box>
          <Typography className="text-xs font-normal text-[#94A0A4]">
            Prepaid balance for future charges
          </Typography>
        </MenuItem>
      )}
    </>
  );
};
